import { useContext } from 'react';

import { ScreenContext } from './ScreenContext';

export const useScreenState = () => {
  return useContext(ScreenContext).state;
};
